// Words for login outcomes and devices, shared by Audit › Logins and the
// tenant Activity tab.

const REASONS: Record<string, string> = {
  bad_password: 'Wrong password',
  no_such_user: 'No such account',
  inactive: 'Account deactivated',
  not_super_admin: 'Not a super-admin',
  rate_limited: 'Too many attempts',
}

/** "bad_password" → "Wrong password"; unknown reasons are humanised. */
export function failureReasonText(reason: string | null | undefined): string {
  if (!reason) return 'Failed'
  return REASONS[reason] ?? reason.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}

/** A short device label from a user-agent string: "Safari on macOS". */
export function deviceText(ua: string | null | undefined): string {
  if (!ua) return '—'
  const os = /iPhone|iPad/.test(ua)
    ? 'iOS'
    : /Android/.test(ua)
      ? 'Android'
      : /Mac OS X|Macintosh/.test(ua)
        ? 'macOS'
        : /Windows/.test(ua)
          ? 'Windows'
          : /Linux/.test(ua)
            ? 'Linux'
            : null
  const browser = /Edg\//.test(ua)
    ? 'Edge'
    : /Firefox\//.test(ua)
      ? 'Firefox'
      : /Chrome\//.test(ua)
        ? 'Chrome'
        : /Safari\//.test(ua)
          ? 'Safari'
          : /curl|node|python|axios/i.test(ua)
            ? 'Script'
            : null
  if (browser && os) return `${browser} on ${os}`
  return browser ?? os ?? (ua.length > 40 ? `${ua.slice(0, 40)}…` : ua)
}
